<mat-nav-list class="navigation" [ngClass]="{ navigation_expanded: isExpanded }">
  <div class="navigation__header">
    <h4 *ngIf="isExpanded" class="navigation__header__title">{{ title }}</h4>
    <button mat-icon-button class="navigation__expand-button" (click)="isExpanded = !isExpanded">
      <mat-icon *ngIf="!isExpanded">chevron_right</mat-icon>
      <mat-icon *ngIf="isExpanded">chevron_left</mat-icon>
    </button>
  </div>
  @if (!isAdmin && isExpanded && hasSelectOptions) {
    <div class="navigation__select">
      <mat-form-field class="navigation__select__dropdown">
        <mat-select multiple placeholder="Select departments" [(ngModel)]="selectedOptions" (selectionChange)="onSelectionChange()">
          <mat-option *ngFor="let option of selectOptions" [value]="option.value">
            {{ option.viewValue }}
          </mat-option>
        </mat-select>
        <mat-hint *ngIf="selectedOptions.length === 0 && !isAdmin">No data would be shown</mat-hint>
        <mat-hint *ngIf="selectedOptions.length === 0 && isAdmin">All data is shown</mat-hint>
      </mat-form-field>
    </div>
  }
  <ng-container *ngFor="let item of navigationItems">
    <app-navigation-item
      *ngIf="item.url && item.icon; else label"
      [link]="item.url"
      [iconName]="item.icon"
      [title]="item.title"
      [isExpanded]="isExpanded"
      (preRedirect)="beforeNavigate.emit()" />
    <ng-template #label>
      <h4 *ngIf="isExpanded" class="navigation__label">
        {{ item.title }}
      </h4>
    </ng-template>
  </ng-container>
  <div class="navigation__space-occupier"></div>
  <app-navigation-item
    class="navigation__logout"
    link="/logout"
    iconName="logout"
    [title]="'Log Out'"
    [isExpanded]="isExpanded"
    (preRedirect)="logoff()" />
</mat-nav-list>
